import { createSlice } from '@reduxjs/toolkit';
import abTestState from '../../../constants/ABTest/abTestState';

// Create a Redux slice for the 'CTA' portion of the state
export const abTestSlice = createSlice({
  name: 'abTest', // The name of the slice
  initialState: abTestState, // Initial state for AB Test
  reducers: {
    setABTestTitle: (state, action) => {
      state.data.title = action.payload;
    },
    setABTestStartDate: (state, action) => {
      state.data.startDate = action.payload;
    },
    setABTestEndDate: (state, action) => {
      state.data.endDate = action.payload;
    },
    setABTestBaseCampaignId: (state, action) => {
      state.data.baseCampaignId = action.payload;
    },
  },
});

// Export the action creators
export const { setABTestTitle, setABTestStartDate, setABTestEndDate, setABTestBaseCampaignId } =
  abTestSlice.actions;

// Export the reducer
export default abTestSlice.reducer;
